import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import agent from "../Services/api"
export const unblockRequest_Process = createAsyncThunk("unblockRequest_Process", (obj) => agent.DcoiApis.unblockRequest_Process(obj));
export const getUnblockRequest = createAsyncThunk("getUnblockRequest", (obj) => agent.DcoiApis.getUnblockRequest(obj));
export const saveUnblockRequest = createAsyncThunk("saveUnblockRequest", (obj) => agent.DcoiApis.saveUnblockRequest(obj));
export const postGetFormLabelByUserName = createAsyncThunk("postGetFormLabelByUserName", (obj) => agent.DcoiApis.postGetFormLabelByUserName(obj));
export const GetSubmissionsByUsername = createAsyncThunk("GetSubmissionsByUsername", (obj) => agent.DcoiApis.GetSubmissionsByUsername(obj));
export const V_GetSubmissionsByUsername = createAsyncThunk("V_GetSubmissionsByUsername", (obj) => agent.DcoiApis.V_GetSubmissionsByUsername(obj));
export const GetDefaulFormLabelByUserName = createAsyncThunk("GetDefaulFormLabelByUserName", (obj) => agent.DcoiApis.GetDefaulFormLabelByUserName(obj));
export const V_GetDefaulFormLabelByUserName = createAsyncThunk("V_GetDefaulFormLabelByUserName", (obj) => agent.DcoiApis.V_GetDefaulFormLabelByUserName(obj));
export const V_GetPolicyByHFMCodeAndLanguageId= createAsyncThunk("V_GetPolicyByHFMCodeAndLanguageId", (obj) => agent.DcoiApis.V_GetPolicyByHFMCodeAndLanguageId(obj));
export const GetUserDetailByUPN = createAsyncThunk("GetUserDetailByUPN", (obj) => agent.DcoiApis.GetUserDetailByUPN(obj));
export const V_GetUserDetailByUPN = createAsyncThunk("V_GetUserDetailByUPN", (obj) => agent.DcoiApis.V_GetUserDetailByUPN(obj));
export const GetAllPolicies = createAsyncThunk("GetAllPolicies", (obj) => agent.DcoiApis.GetAllPolicies(obj));
export const V_GetAllPolicies = createAsyncThunk("V_GetAllPolicies", (obj) => agent.DcoiApis.V_GetAllPolicies(obj));

export const GetAdminGroupsByUPN = createAsyncThunk("GetAdminGroupsByUPN", (obj) => agent.DcoiApis.GetAdminGroupsByUPN(obj));
export const V_GetAdminGroupsByUPN = createAsyncThunk("V_GetAdminGroupsByUPN", (obj) => agent.DcoiApis.V_GetAdminGroupsByUPN(obj));
export const GetAllEmailTemplates = createAsyncThunk("GetAllEmailTemplates", (obj) => agent.DcoiApis.GetAllEmailTemplates(obj));
export const V_GetAllEmailTemplates = createAsyncThunk("V_GetAllEmailTemplates", (obj) => agent.DcoiApis.V_GetAllEmailTemplates(obj));

export const GetAllEntities = createAsyncThunk("GetAllEntities", (obj) => agent.DcoiApis.GetAllEntities(obj));
export const V_GetAllEntities = createAsyncThunk("V_GetAllEntities", (obj) => agent.DcoiApis.V_GetAllEntities(obj));
export const GetAllEntitiesBase = createAsyncThunk("GetAllEntitiesBase", (obj) => agent.DcoiApis.GetAllEntities(obj));
export const V_GetAllEntitiesBase = createAsyncThunk("V_GetAllEntitiesBase", (obj) => agent.DcoiApis.V_GetAllEntities(obj));
export const GetAllAgencies = createAsyncThunk("GetAllAgencies", (obj) => agent.DcoiApis.GetAllAgencies(obj));
export const V_GetAllAgencies = createAsyncThunk("V_GetAllAgencies", (obj) => agent.DcoiApis.V_GetAllAgencies(obj));
export const GetAllCountries = createAsyncThunk("GetAllCountries", (obj) => agent.DcoiApis.GetAllCountries(obj));
export const V_GetAllCountries = createAsyncThunk("V_GetAllCountries", (obj) => agent.DcoiApis.V_GetAllCountries(obj));
export const GetAllPolicyByHFMCode = createAsyncThunk("GetAllPolicyByHFMCode", (obj) => agent.DcoiApis.GetAllPolicyByHFMCode(obj));
export const GetAllFormLabels = createAsyncThunk("GetAllFormLabels", (obj) => agent.DcoiApis.GetAllFormLabels(obj));
export const V_GetAllFormLabels = createAsyncThunk("V_GetAllFormLabels", (obj) => agent.DcoiApis.V_GetAllFormLabels(obj));
export const GetAllEntitiesForUserAdmin = createAsyncThunk("GetAllEntitiesForUserAdmin", (obj) => agent.DcoiApis.GetAllEntitiesForUserAdmin(obj));
export const V_GetAllEntitiesForUserAdmin = createAsyncThunk("V_GetAllEntitiesForUserAdmin", (obj) => agent.DcoiApis.V_GetAllEntitiesForUserAdmin(obj));
export const Getsumission = createAsyncThunk("getsumission", (obj) => agent.DcoiApis.getsumission(obj));
export const V_Getsumission = createAsyncThunk("V_Getsumission", (obj) => agent.DcoiApis.V_Getsumission(obj));
export const GetAllSolutionHub = createAsyncThunk("GetAllSolutionHub", (obj) => agent.DcoiApis.GetAllSolutionHub(obj));
export const SubmitForm = createAsyncThunk("SubmitForm", (obj) => agent.DcoiApis.SubmitForm(obj));
export const SubmitV_Form = createAsyncThunk("SubmitV_Form", (obj) => agent.DcoiApis.SubmitV_Form(obj));
export const GetUsersAndGroups = createAsyncThunk("GetUsersAndGroups", (obj) => agent.DcoiApis.GetUsersAndGroups(obj));
export const V_GetUsersAndGroups = createAsyncThunk("V_GetUsersAndGroups", (obj) => agent.DcoiApis.V_GetUsersAndGroups(obj));
export const SubmitCycle = createAsyncThunk("SubmitCycle", (obj) => agent.DcoiApis.SubmitCycle(obj));
export const GetAllEntitiesWithActiveCycle = createAsyncThunk("GetAllEntitiesWithActiveCycle", (obj) => agent.DcoiApis.GetAllEntitiesWithActiveCycle(obj));
export const DeleteUserFromGroup = createAsyncThunk("DeleteUserFromGroup", (obj) => agent.DcoiApis.DeleteUserFromGroup(obj));
export const AddUserInGroup = createAsyncThunk("AddUserInGroup", (obj) => agent.DcoiApis.AddUserInGroup(obj));
export const V_AddUserInGroup = createAsyncThunk("V_AddUserInGroup", (obj) => agent.DcoiApis.V_AddUserInGroup(obj));
export const SavePolicy = createAsyncThunk("SavePolicy", (obj) => agent.DcoiApis.SavePolicy(obj));
export const V_SavePolicy = createAsyncThunk("V_SavePolicy", (obj) => agent.DcoiApis.V_SavePolicy(obj));
export const GetAdminGroups = createAsyncThunk("GetAdminGroups", (obj) => agent.DcoiApis.GetAdminGroups(obj));
export const V_GetAdminGroups = createAsyncThunk("V_GetAdminGroups", (obj) => agent.DcoiApis.V_GetAdminGroups(obj));

export const SaveEmailTemplate = createAsyncThunk("SaveEmailTemplate", (obj) => agent.DcoiApis.SaveEmailTemplate(obj));
export const V_SaveEmailTemplate = createAsyncThunk("V_SaveEmailTemplate", (obj) => agent.DcoiApis.V_SaveEmailTemplate(obj));

export const AddGroup = createAsyncThunk("AddGroup", (obj) => agent.DcoiApis.AddGroup(obj));
export const V_AddGroup = createAsyncThunk("V_AddGroup", (obj) => agent.DcoiApis.V_AddGroup(obj));
export const GetSolutionHubs = createAsyncThunk("GetSolutionHubs", (obj) => agent.DcoiApis.GetSolutionHubs(obj));
export const V_GetSolutionHubs = createAsyncThunk("V_GetSolutionHubs", (obj) => agent.DcoiApis.V_GetSolutionHubs(obj));
export const GetAdminPermission = createAsyncThunk("GetAdminPermission", (obj) => agent.DcoiApis.GetAdminPermission(obj));
export const V_GetAdminPermission = createAsyncThunk("V_GetAdminPermission", (obj) => agent.DcoiApis.V_GetAdminPermission(obj));


export const DeletePolicy = createAsyncThunk("DeletePolicy", (obj) => agent.DcoiApis.DeletePolicy(obj));
export const V_DeletePolicy = createAsyncThunk("V_DeletePolicy", (obj) => agent.DcoiApis.V_DeletePolicy(obj));
export const DeleteEmailTemplate = createAsyncThunk("DeleteEmailTemplate", (obj) => agent.DcoiApis.DeleteEmailTemplate(obj));
export const V_DeleteEmailTemplate = createAsyncThunk("V_DeleteEmailTemplate", (obj) => agent.DcoiApis.V_DeleteEmailTemplate(obj));
export const ResetStatus = createAsyncThunk("ResetStatus", (obj) => agent.DcoiApis.ResetStatus(obj));
export const SaveAgency = createAsyncThunk("SaveAgency", (obj) => agent.DcoiApis.SaveAgency(obj));
export const V_SaveAgency = createAsyncThunk("V_SaveAgency", (obj) => agent.DcoiApis.V_SaveAgency(obj));
export const SaveCountry = createAsyncThunk("SaveCountry", (obj) => agent.DcoiApis.SaveCountry(obj));
export const V_SaveCountry = createAsyncThunk("V_SaveCountry", (obj) => agent.DcoiApis.V_SaveCountry(obj));
export const DeleteEntity = createAsyncThunk("DeleteEntity", (obj) => agent.DcoiApis.DeleteEntity(obj));
export const SaveEntity = createAsyncThunk("SaveEntity", (obj) => agent.DcoiApis.SaveEntity(obj));
export const DeleteFormLabels = createAsyncThunk("DeleteFormLabels", (obj) => agent.DcoiApis.DeleteFormLabels(obj));
export const SaveFormLabels = createAsyncThunk("SaveFormLabels", (obj) => agent.DcoiApis.SaveFormLabels(obj));
export const GetPolicyandEmailSetting = createAsyncThunk("GetPolicyandEmailSetting", (obj) => agent.DcoiApis.GetPolicyandEmailSetting(obj));
export const V_GetPolicyandEmailSetting = createAsyncThunk("V_GetPolicyandEmailSetting", (obj) => agent.DcoiApis.V_GetPolicyandEmailSetting(obj));
export const SavePolicyandEmailSetting = createAsyncThunk("SavePolicyandEmailSetting", (obj) => agent.DcoiApis.SavePolicyandEmailSetting(obj));
export const DeletePolicyandEmailSetting = createAsyncThunk("DeletePolicyandEmailSetting", (obj) => agent.DcoiApis.DeletePolicyandEmailSetting(obj));
export const SaveAdminPermission = createAsyncThunk("SaveAdminPermission", (obj) => agent.DcoiApis.SaveAdminPermission(obj));
export const V_SaveAdminPermission = createAsyncThunk("V_SaveAdminPermission", (obj) => agent.DcoiApis.V_SaveAdminPermission(obj));
export const DeleteAdminPermission = createAsyncThunk("DeleteAdminPermission", (obj) => agent.DcoiApis.DeleteAdminPermission(obj));
export const V_DeleteAdminPermission = createAsyncThunk("V_DeleteAdminPermission", (obj) => agent.DcoiApis.V_DeleteAdminPermission(obj));
export const RespondentDashboard = createAsyncThunk("RespondentDashboard", (obj) => agent.DcoiApis.RespondentDashboard(obj));
export const V_RespondentDashboard = createAsyncThunk("V_RespondentDashboard", (obj) => agent.DcoiApis.V_RespondentDashboard(obj));
export const RespondentDocuments = createAsyncThunk("RespondentDocuments", (obj) => agent.DcoiApis.RespondentDocuments(obj));
export const V_RespondentDocuments = createAsyncThunk("V_RespondentDocuments", (obj) => agent.DcoiApis.V_RespondentDocuments(obj));
export const UnblockUsers = createAsyncThunk("UnblockUsers", (obj) => agent.DcoiApis.UnblockUsers(obj));
export const GetSubmissionPdfDocZip = createAsyncThunk("GetSubmissionPdfDocZip", (obj) => agent.DcoiApis.GetSubmissionPdfDocZip(obj));
export const V_GetSubmissionPdfDocZip = createAsyncThunk("V_GetSubmissionPdfDocZip", (obj) => agent.DcoiApis.V_GetSubmissionPdfDocZip(obj));
export const downloadExcelReport = createAsyncThunk("downloadExcelReport", (obj) => agent.DcoiApis.downloadExcelReport(obj));
export const V_downloadExcelReport = createAsyncThunk("V_downloadExcelReport", (obj) => agent.DcoiApis.V_downloadExcelReport(obj));
export const RemindUser = createAsyncThunk("RemindUser", (obj) => agent.DcoiApis.RemindUser(obj));
export const V_RemindUser = createAsyncThunk("V_RemindUser",(obj) => agent.DcoiApis.V_SendReminder(obj));
export const UserFormData = createAsyncThunk("UserFormData", (obj) => agent.DcoiApis.UserFormData(obj));
export const GetAllCycleForEntity = createAsyncThunk("GetAllCycleForEntity", (obj) => agent.DcoiApis.GetAllCycleForEntity(obj));
export const DeleteCycleForEntity = createAsyncThunk("DeleteCycleForEntity", (obj) => agent.DcoiApis.DeleteCycleForEntity(obj));
export const GetAdminGroupsByUPNNotMappedWithEntity = createAsyncThunk("GetAdminGroupsByUPNNotMappedWithEntity", (obj) => agent.DcoiApis.GetAdminGroupsByUPNNotMappedWithEntity(obj));
export const V_GetAdminGroupsByUPNNotMappedWithEntity = createAsyncThunk("V_GetAdminGroupsByUPNNotMappedWithEntity", (obj) => agent.DcoiApis.V_GetAdminGroupsByUPNNotMappedWithEntity(obj));
export const SendInvitationAndReminder = createAsyncThunk("SendInvitationAndReminder", (obj) => agent.DcoiApis.SendInvitationAndReminder(obj));
export const V_SendInvitationAndReminder = createAsyncThunk("V_SendInvitationAndReminder", (obj) => agent.DcoiApis.V_SendInvitationAndReminder(obj));
export const GetPolicyByHFMCodeAndLanguageId = createAsyncThunk("GetPolicyByHFMCodeAndLanguageId", (obj) => agent.DcoiApis.GetPolicyByHFMCodeAndLanguageId(obj));
export const V_AllRespondents = createAsyncThunk("V_AllRespondents", (obj) => agent.DcoiApis.V_AllRespondents(obj));
export const DownloadArchivalExcelReport = createAsyncThunk("DownloadArchivalExcelReport", (obj) => agent.DcoiApis.DownloadArchivalExcelReport(obj));
const initialState = {
  isUnblock:false,
  error: "",
  PolicyAndEmailSetting: [],
  V_PolicyAndEmailSetting:[],
  AdminPermissionList: [],
  V_AdminPermissionList:[],
  SolutionHubs: [],
  V_SolutionHubs:[],
  AdminGroups: [],
  V_GetAdminGroups:[],
  activeCycleEntity: [],
  userAndGroup: [],
  V_userAndGroup:[],
  inProgress: false,
  AllEntitiesForUserAdmin: [],
  V_AllEntitiesForUserAdmin:[],
  languageId: "",
  languageList: [],
  V_languageList:[],
  aggrementPolicies: [],
  emailTemplatesList: [],
  V_emailTemplatesList:[],
  entityList: [],
  V_entityList:[],
  agenciesList: [],
  V_agenciesList:[],
  solutionHubList: [],
  countriesList: [],
  V_countriesList:[],
  policiesList: [],
  V_policiesList:[],
  policiesListByUPN: [],
  V_policiesListByUPN:[],
  userDetails: [],
  languageDropdown: [],
  userformDataList: [],
  languageData: [],
  V_languageData:[],
  V_userformDataList:[],
  pdfFile: "",
  V_pdfFile:"",
  formResponse: "",
  menu: "",
  subMenu: "",
  PolicyAndEmailSettingMatch: [],
  RespondentDashboardData: [],
  V_RespondentDashboardData:[],
  RespondentDashboardUsers: [],
  V_RespondentDashboardUsers:[],
  RespondentDocumentsData: [],
  V_RespondentDocumentsData:[],
  userFormDataValue: [],
  userFormDataValue1: [],
  entityListBase: [],
  V_entityListBase:[],
  UpcommingCycle: [],
  NotMappedWithEntityList: [],
  V_NotMappedWithEntityList:[],
  V_PolicyDataNew:[],
};

const DcoiSlice = createSlice({
  name: "DcoiSliceData",
  initialState,
  reducers: {
    DcoiState: () => initialState,
    setUserDetails(state, action) {
      state.userDetails = action.payload;
    },
    setFormLabelsData(state, action){
      const list = action.payload.list;
      const id = action.payload.id;
      const selectedLanguage = list?.find(
        (item) => item.ID == id
      );
      state.languageData = selectedLanguage || {};
    },
    activeDisplay(state, action) {
      state.menu = action.payload.menu;
      state.subMenu = action.payload.subMenu;
    }

  },
  extraReducers: (builder) => {


    builder.addCase(GetDefaulFormLabelByUserName.pending, (state) => {
      state.inProgress = true;
    });

    builder.addCase(GetDefaulFormLabelByUserName.fulfilled, (state, action) => {
      state.languageData = Array.isArray(action.payload?.data)
        ? action.payload.data[0] : []
      state.inProgress = false;
    });

    builder.addCase(GetDefaulFormLabelByUserName.rejected, (state, action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(V_GetDefaulFormLabelByUserName.pending, (state) => {
      state.inProgress = true;
    });

    builder.addCase(V_GetDefaulFormLabelByUserName
      .fulfilled, (state, action) => {
      state.V_languageData = Array.isArray(action.payload?.data)
        ? action.payload.data[0] : []
      state.inProgress = false;
    });

    builder.addCase(V_GetDefaulFormLabelByUserName.rejected, (state, action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })



    builder.addCase(postGetFormLabelByUserName.pending, (state) => {
      state.inProgress = true;
    });

    builder.addCase(postGetFormLabelByUserName.fulfilled, (state, action) => {
      state.languageDropdown = action.payload.data;
        // ? action.payload.data : [];
      state.inProgress = false;
    });

    builder.addCase(postGetFormLabelByUserName.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(GetSubmissionsByUsername.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetSubmissionsByUsername.fulfilled, (state, action) => {
      state.userformDataList = Array.isArray(action.payload?.data)
        ? action.payload.data : []
      state.inProgress = false;
    })

    builder.addCase(GetSubmissionsByUsername.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(V_GetSubmissionsByUsername.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetSubmissionsByUsername.fulfilled, (state, action) => {
      state.V_userformDataList = Array.isArray(action.payload?.data)
        ? action.payload.data : []
      state.inProgress = false;
    })

    builder.addCase(V_GetSubmissionsByUsername.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(GetUserDetailByUPN.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetUserDetailByUPN.fulfilled, (state, action) => {
      state.userDetails = Array.isArray(action.payload?.data) ? action.payload.data[0] :{}
      state.inProgress = false;
    })

    builder.addCase(GetAllPolicies.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetAllPolicies.pending, (state) => {
      state.inProgress = true;
    })


    
    builder.addCase(V_GetUserDetailByUPN.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetUserDetailByUPN.fulfilled, (state, action) => {
      state.V_userDetails = Array.isArray(action.payload?.data) ? action.payload.data[0] :{}
      state.inProgress = false;
    })


    builder.addCase(GetAllPolicies.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(V_GetAllPolicies.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(GetAllPolicies.fulfilled, (state, action) => {
      state.policiesList = Array.isArray(action.payload?.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.ID,
          Label: item.Title,
          Value: item.ID
        }))
        : []; // Return an array with an empty object if data is not an array  
      state.inProgress = false;
    })

    builder.addCase(V_GetAllPolicies.fulfilled, (state, action) => {
      state.V_policiesList = Array.isArray(action.payload?.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.ID,
          Label: item.Title,
          Value: item.ID
        }))
        : []; // Return an array with an empty object if data is not an array  
      state.inProgress = false;
    })



    builder.addCase(GetAdminGroupsByUPN.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAdminGroupsByUPN.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetAdminGroupsByUPN.fulfilled, (state, action) => {
      state.policiesListByUPN = Array.isArray(action.payload?.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.ID,
          Label: item.Title,
          Value: item.ID
        }))
        : []; // Return an array with an empty object if data is not an array  
      state.inProgress = false;
    })

    builder.addCase(V_GetAdminGroupsByUPN.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetAdminGroupsByUPN.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_GetAdminGroupsByUPN.fulfilled, (state, action) => {
      state.V_policiesListByUPN = Array.isArray(action.payload?.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.ID,
          Label: item.Title,
          Value: item.ID
        }))
        : []; // Return an array with an empty object if data is not an array  
      state.inProgress = false;
    })



    builder.addCase(GetAllEmailTemplates.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAllEmailTemplates.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetAllEmailTemplates.fulfilled, (state, action) => {
      state.emailTemplatesList = Array.isArray(action.payload?.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.ID,
          Label: item.Title,
          Value: item.ID
        }))
        : []; // Return an array with an empty object if data is not an array  
      state.inProgress = false;
    })


    builder.addCase(V_GetAllEmailTemplates.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetAllEmailTemplates.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_GetAllEmailTemplates.fulfilled, (state, action) => {
      state.V_emailTemplatesList = Array.isArray(action.payload?.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.ID,
          Label: item.Title,
          Value: item.ID
        }))
        : []; // Return an array with an empty object if data is not an array  
      state.inProgress = false;
    })



    

    builder.addCase(GetAllEntities.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAllEntities.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetAllEntities.fulfilled, (state, action) => {
      if (!Array.isArray(action.payload?.data)) {
        state.entityList = [];
        state.inProgress = false;
        return;
      }

      const uniqueData = [];
      const seenUserGroups = new Set();

      for (const item of action.payload.data) {
        if (!seenUserGroups.has(item.UserGroup)) {
          uniqueData.push(item);
          seenUserGroups.add(item.UserGroup);
        }
      }

      state.entityList = uniqueData.map(item => ({
        ...item,
        id: item.UserGroupID,
        Label: item.UserGroup,
        Value: item.EntityName
      }));

      state.inProgress = false;
    });

    builder.addCase(V_GetAllEntities.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetAllEntities.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_GetAllEntities.fulfilled, (state, action) => {
      if (!Array.isArray(action.payload?.data)) {
        state.V_entityList = [];
        state.inProgress = false;
        return;
      }

      const uniqueData = [];
      const seenUserGroups = new Set();

      for (const item of action.payload.data) {
        if (!seenUserGroups.has(item.UserGroup)) {
          uniqueData.push(item);
          seenUserGroups.add(item.UserGroup);
        }
      }

      state.V_entityList = uniqueData.map(item => ({
        ...item,
        id: item.UserGroupID,
        Label: item.UserGroup,
        Value: item.EntityName
      }));

      state.inProgress = false;
    });

    

    builder.addCase(GetAllEntitiesBase.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAllEntitiesBase.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetAllEntitiesBase.fulfilled, (state, action) => {
      state.entityListBase =Array.isArray(action.payload.data)
      ? action.payload.data
      : [];
      state.inProgress = false;
    });

    builder.addCase(V_GetAllEntitiesBase.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetAllEntitiesBase.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_GetAllEntitiesBase.fulfilled, (state, action) => {
      state.V_entityListBase =Array.isArray(action.payload.data)
      ? action.payload.data
      : [];
      state.inProgress = false;
    });


    
    // builder.addCase(V_GetAllEntities.pending, (state) => {
    //   state.inProgress = true;
    // })

    // builder.addCase(V_GetAllEntities.rejected, (state,action) => {
    //   // state.error = action.error.message;
    //   state.inProgress = false;
    // })

    // builder.addCase(V_GetAllEntities.fulfilled, (state, action) => {
    //   state.V_entityList=Array.isArray(action.payload.data)
    //   ? action.payload.data
    //   : [];
    //   state.inProgress = false;
    // });

    builder.addCase(GetAllAgencies.pending, (state) => {
      state.inProgress = true;
    })



    builder.addCase(GetAllAgencies.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetAllAgencies.fulfilled, (state, action) => {
      state.agenciesList = Array.isArray(action.payload?.data)
        ? action.payload.data.map(item => ({
          id: item.ID,
          Label: item.Name,
          Value: item.Code
        }))
        : []; // Return an array with an empty object if data is not an array

      state.inProgress = false;
    })

    builder.addCase(V_GetAllAgencies.pending, (state) => {
      state.inProgress = true;
    })



    builder.addCase(V_GetAllAgencies.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_GetAllAgencies.fulfilled, (state, action) => {
      state.V_agenciesList = Array.isArray(action.payload?.data)
        ? action.payload.data.map(item => ({
          id: item.ID,
          Label: item.Name,
          Value: item.Code
        }))
        : []; // Return an array with an empty object if data is not an array

      state.inProgress = false;
    })


    

    builder.addCase(GetAllCountries.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAllCountries.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetAllCountries.fulfilled, (state, action) => {
      state.countriesList = Array.isArray(action.payload?.data)
        ? action.payload.data.map(item => ({
          id: item.ID,
          Label: item.Name,
          Value: item.Code
        }))
        : []; // Return an array with an empty object if data is not an array


      state.inProgress = false;
    })

    builder.addCase(V_GetAllCountries.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetAllCountries.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_GetAllCountries.fulfilled, (state, action) => {
      state.V_countriesList = Array.isArray(action.payload?.data)
        ? action.payload.data.map(item => ({
          id: item.ID,
          Label: item.Name,
          Value: item.Code
        }))
        : []; // Return an array with an empty object if data is not an array


      state.inProgress = false;
    })

    builder.addCase(GetAllPolicyByHFMCode.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAllPolicyByHFMCode.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetAllPolicyByHFMCode.fulfilled, (state, action) => {
      state.aggrementPolicies = Array.isArray(action.payload.data)
        ? action.payload.data.find(item => item.FormLabelId === state.languageId)
        : undefined; // Return undefined if data is not an array
      state.inProgress = false;
    })


    builder.addCase(GetAllFormLabels.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAllFormLabels.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetAllFormLabels.fulfilled, (state, action) => {
      state.languageList = Array.isArray(action.payload.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.ID,
          Label: item.Language,
          Value: item.LanguageCode
        }))
        : []; // Return an empty array if action.payload.data is not an array  
      state.inProgress = false;
    })

    builder.addCase(V_GetAllFormLabels.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetAllFormLabels.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_GetAllFormLabels.fulfilled, (state, action) => {
      state.V_languageList = Array.isArray(action.payload.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.ID,
          Label: item.Language,
          Value: item.LanguageCode
        }))
        : []; // Return an empty array if action.payload.data is not an array  
      state.inProgress = false;
    })

    

    builder.addCase(GetAllEntitiesForUserAdmin.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAllEntitiesForUserAdmin.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetAllEntitiesForUserAdmin.fulfilled, (state, action) => {

      state.AllEntitiesForUserAdmin = Array.isArray(action.payload.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.ID,
          Label: `${item.EntityName} - ${item.EntityDescription}`,
          Value: item.EntityName
        }))
        : []; // Return an empty array if action.payload.data is not an array

      state.inProgress = false;
    })

        builder.addCase(V_GetAllEntitiesForUserAdmin.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetAllEntitiesForUserAdmin.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_GetAllEntitiesForUserAdmin.fulfilled, (state, action) => {
      state.V_AllEntitiesForUserAdmin = Array.isArray(action.payload.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.ID,
          Label: `${item.EntityName} - ${item.EntityDescription}`,
          Value: item.EntityName
        }))
        : []; // Return an empty array if action.payload.data is not an array

      state.inProgress = false;
    })


    builder.addCase(Getsumission.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(Getsumission.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(Getsumission.fulfilled, (state, action) => {
      state.pdfFile = action.payload.data;
      state.inProgress = false;
    })

        builder.addCase(V_Getsumission.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_Getsumission.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(V_Getsumission.fulfilled, (state, action) => {
      state.V_pdfFile = action.payload.data;
      state.inProgress = false;
    })

    builder.addCase(GetAllSolutionHub.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAllSolutionHub.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(GetAllSolutionHub.fulfilled, (state, action) => {
      state.solutionHubList = Array.isArray(action.payload.data) ? action.payload.data : [];
      state.inProgress = false;
    })

    builder.addCase(SubmitForm.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(SubmitForm.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(SubmitForm.fulfilled, (state, action) => {
      state.formResponse = action.payload.data;
      state.inProgress = false;
    })

    builder.addCase(SubmitV_Form.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(SubmitV_Form.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(SubmitV_Form.fulfilled, (state, action) => {
      state.formResponse = action.payload.data;
      state.inProgress = false;
    })

    builder.addCase(GetUsersAndGroups.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetUsersAndGroups.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetUsersAndGroups.fulfilled, (state, action) => {
      // if(action.meta.arg.groupid){
      state.userAndGroup = Array.isArray(action.payload.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.GroupId,
          Label: item.GroupName,
          Value: item.GroupId
        }))
        : []; // Return an empty array if action.payload.data is not an array


      state.inProgress = false;
    })

    builder.addCase(V_GetUsersAndGroups.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetUsersAndGroups.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_GetUsersAndGroups.fulfilled, (state, action) => {
      // if(action.meta.arg.groupid){
      state.V_userAndGroup = Array.isArray(action.payload.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.GroupId,
          Label: item.GroupName,
          Value: item.GroupId
        }))
        : []; // Return an empty array if action.payload.data is not an array


      state.inProgress = false;
    })

    

    builder.addCase(GetAllEntitiesWithActiveCycle.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAllEntitiesWithActiveCycle.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetAllEntitiesWithActiveCycle.fulfilled, (state, action) => {
      state.activeCycleEntity = Array.isArray(action.payload.data) ? action.payload.data : [];
      state.inProgress = false;
    })

    builder.addCase(SubmitCycle.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(SubmitCycle.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(SubmitCycle.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(DeleteUserFromGroup.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(DeleteUserFromGroup.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(DeleteUserFromGroup.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(AddUserInGroup.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(AddUserInGroup.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(AddUserInGroup.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(V_AddUserInGroup.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_AddUserInGroup.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_AddUserInGroup.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    

    builder.addCase(SavePolicy.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(SavePolicy.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(SavePolicy.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(V_SavePolicy.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_SavePolicy.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_SavePolicy.fulfilled, (state, action) => {
      state.inProgress = false;
    })


    builder.addCase(GetAdminGroups.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAdminGroups.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetAdminGroups.fulfilled, (state, action) => {
      state.AdminGroups = Array.isArray(action.payload.data) ? action.payload.data : [];
      state.inProgress = false;
    })


    builder.addCase(V_GetAdminGroups.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetAdminGroups.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_GetAdminGroups.fulfilled, (state, action) => {
      state.V_AdminGroups = Array.isArray(action.payload.data) ? action.payload.data : [];
      state.inProgress = false;
    })


    

    builder.addCase(SaveEmailTemplate.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(SaveEmailTemplate.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(SaveEmailTemplate.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(V_SaveEmailTemplate.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_SaveEmailTemplate.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_SaveEmailTemplate.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    

    builder.addCase(AddGroup.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(AddGroup.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(AddGroup.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(V_AddGroup.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_AddGroup.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_AddGroup.fulfilled, (state, action) => {
      state.inProgress = false;
    })


    

    builder.addCase(GetSolutionHubs.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetSolutionHubs.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetSolutionHubs.fulfilled, (state, action) => {
      state.SolutionHubs = Array.isArray(action.payload.data) ? action.payload.data :[];
      state.inProgress = false;
    })

    builder.addCase(V_GetSolutionHubs.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetSolutionHubs.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_GetSolutionHubs.fulfilled, (state, action) => {
      state.V_SolutionHubs = Array.isArray(action.payload.data) ? action.payload.data :[];
      state.inProgress = false;
    })

    builder.addCase(GetAdminPermission.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAdminPermission.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetAdminPermission.fulfilled, (state, action) => {
      if (!Array.isArray(action.payload.data)) {
        state.AdminPermissionList = [];
        state.inProgress = false;
        return;
      }

      // Maps to store grouped data
      const countryMap = new Map();
      const groupMap = new Map();

      action.payload.data.forEach(({ CountryId, CountryName, EntityId, Entity, EntityAdminGroupId, EntityAdminGroup }) => {
        const adminGroupId = EntityAdminGroupId ?? null;
        const adminGroupName = EntityAdminGroup ?? "No Admin Group";

        // Only add to AdminGroups if EntityAdminGroupId is NOT null
        if (adminGroupId !== null) {
          if (!groupMap.has(adminGroupId)) {
            groupMap.set(adminGroupId, {
              EntityAdminGroupId: adminGroupId,
              EntityAdminGroup: adminGroupName,
              Entities: []
            });
          }
          groupMap.get(adminGroupId).Entities.push({ EntityId, Entity, CountryId, CountryName });
        }

        // Group by CountryId (including entities with null EntityAdminGroupId)
        if (!countryMap.has(CountryId)) {
          countryMap.set(CountryId, {
            CountryId,
            CountryName,
            Entities: []
          });
        }
        countryMap.get(CountryId).Entities.push({ EntityId, Entity, EntityAdminGroupId: adminGroupId, EntityAdminGroup: adminGroupName });
      });

      // Convert maps to arrays
      const groupedCountries = Array.from(countryMap.values());
      const groupedEntities = Array.from(groupMap.values()); // Entities with valid EntityAdminGroupId only

      // Store sorted results
      state.AdminPermissionList = {
        Countries: groupedCountries,
        AdminGroups: groupedEntities
      };
      state.inProgress = false;
    });

    builder.addCase(V_GetAdminPermission.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetAdminPermission.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_GetAdminPermission.fulfilled, (state, action) => {
      if (!Array.isArray(action.payload.data)) {
        state.V_AdminPermissionList = [];
        state.inProgress = false;
        return;
      }

      // Maps to store grouped data
      const countryMap = new Map();
      const groupMap = new Map();

      action.payload.data.forEach(({ CountryId, CountryName, EntityId, Entity, EntityAdminGroupId, EntityAdminGroup }) => {
        const adminGroupId = EntityAdminGroupId ?? null;
        const adminGroupName = EntityAdminGroup ?? "No Admin Group";

        // Only add to AdminGroups if EntityAdminGroupId is NOT null
        if (adminGroupId !== null) {
          if (!groupMap.has(adminGroupId)) {
            groupMap.set(adminGroupId, {
              EntityAdminGroupId: adminGroupId,
              EntityAdminGroup: adminGroupName,
              Entities: []
            });
          }
          groupMap.get(adminGroupId).Entities.push({ EntityId, Entity, CountryId, CountryName });
        }

        // Group by CountryId (including entities with null EntityAdminGroupId)
        if (!countryMap.has(CountryId)) {
          countryMap.set(CountryId, {
            CountryId,
            CountryName,
            Entities: []
          });
        }
        countryMap.get(CountryId).Entities.push({ EntityId, Entity, EntityAdminGroupId: adminGroupId, EntityAdminGroup: adminGroupName });
      });

      // Convert maps to arrays
      const groupedCountries = Array.from(countryMap.values());
      const groupedEntities = Array.from(groupMap.values()); // Entities with valid EntityAdminGroupId only

      // Store sorted results
      state.V_AdminPermissionList = {
        Countries: groupedCountries,
        AdminGroups: groupedEntities
      };
      state.inProgress = false;
    });






    // builder.addCase(GetAdminPermission.pending, (state) => {
    //     state.inProgress = true;
    // });



    builder.addCase(SaveAdminPermission.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(SaveAdminPermission.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(SaveAdminPermission.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    
    builder.addCase(V_SaveAdminPermission.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_SaveAdminPermission.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_SaveAdminPermission.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    


    builder.addCase(DeleteAdminPermission.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(DeleteAdminPermission.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(DeleteAdminPermission.fulfilled, (state, action) => {
      state.inProgress = false;
    })




    builder.addCase(DeletePolicy.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(DeletePolicy.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(DeletePolicy.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(V_DeletePolicy.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_DeletePolicy.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_DeletePolicy.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(DeleteEmailTemplate.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(DeleteEmailTemplate.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(DeleteEmailTemplate.fulfilled, (state, action) => {
      state.inProgress = false;
    })


    builder.addCase(V_DeleteEmailTemplate.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_DeleteEmailTemplate.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_DeleteEmailTemplate.fulfilled, (state, action) => {
      state.inProgress = false;
    })


    builder.addCase(ResetStatus.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(ResetStatus.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(ResetStatus.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(SaveAgency.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(SaveAgency.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(SaveAgency.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(V_SaveAgency.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_SaveAgency.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_SaveAgency.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(SaveCountry.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(SaveCountry.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(SaveCountry.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(V_SaveCountry.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_SaveCountry.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_SaveCountry.fulfilled, (state, action) => {
      state.inProgress = false;
    })


    

    builder.addCase(DeleteEntity.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(DeleteEntity.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(DeleteEntity.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(SaveEntity.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(SaveEntity.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(SaveEntity.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(DeleteFormLabels.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(DeleteFormLabels.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(DeleteFormLabels.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(SaveFormLabels.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(SaveFormLabels.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(SaveFormLabels.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(GetPolicyandEmailSetting.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetPolicyandEmailSetting.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(GetPolicyandEmailSetting.fulfilled, (state, action) => {
      if (!action.payload?.data) {
        console.error("No data received in action payload");
        return;
      }
      const groupedData = Array.isArray(action.payload.data)
        ? action.payload.data.reduce((acc, item) => {
          let existingEntity = acc.find((e) => e.EntityId === item.EntityId);

          if (!existingEntity) {
            existingEntity = {
              UserGroupId: item.UserGroupId,
              EntityId: item.EntityId,
              HfmCode: item.HfmCode,
              EntityAdminGroup: item.EntityAdminGroup,
              Mappings: [],
            };
            acc.push(existingEntity);
          }

          existingEntity.Mappings.push({
            Language: item.Language,
            PolicyTitle: item.PolicyTitle,
            EmailTemplateTitle: item.EmailTemplateTitle,
            FormLabelId: item.FormLabelId,
            PolicyId: item.PolicyId,
            EmailTemplateId: item.EmailTemplateId,
            Mapping: item.Mapping,
            isDefaultMapping: item.isDefaultMapping,
          });

          return acc;
        }, [])
        : []; // Return an empty array if action.payload.data is not an array

      // Assign grouped data to state
      state.PolicyAndEmailSetting = groupedData;
      state.inProgress = false;
    });

        builder.addCase(V_GetPolicyandEmailSetting.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetPolicyandEmailSetting.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_GetPolicyandEmailSetting.fulfilled, (state, action) => {
      if (!action.payload?.data) {
        console.error("No data received in action payload");
        return;
      }
      const groupedData = Array.isArray(action.payload.data)
        ? action.payload.data.reduce((acc, item) => {
          let existingEntity = acc.find((e) => e.EntityId === item.EntityId);

          if (!existingEntity) {
            existingEntity = {
              UserGroupId: item.UserGroupId,
              EntityId: item.EntityId,
              HfmCode: item.HfmCode,
              EntityAdminGroup: item.EntityAdminGroup,
              Mappings: [],
            };
            acc.push(existingEntity);
          }

          existingEntity.Mappings.push({
            Language: item.Language,
            PolicyTitle: item.PolicyTitle,
            EmailTemplateTitle: item.EmailTemplateTitle,
            FormLabelId: item.FormLabelId,
            PolicyId: item.PolicyId,
            EmailTemplateId: item.EmailTemplateId,
            Mapping: item.Mapping,
            isDefaultMapping: item.isDefaultMapping,
          });

          return acc;
        }, [])
        : []; // Return an empty array if action.payload.data is not an array

      // Assign grouped data to state
      state.V_PolicyAndEmailSetting = groupedData;
      state.inProgress = false;
    });

    



    builder.addCase(SavePolicyandEmailSetting.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(SavePolicyandEmailSetting.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(SavePolicyandEmailSetting.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(DeletePolicyandEmailSetting.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(DeletePolicyandEmailSetting.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(DeletePolicyandEmailSetting.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(RespondentDashboard.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(RespondentDashboard.rejected, (state, action) => {
      // state.error = action.error.message
      state.RespondentDashboardUsers = [];
      state.RespondentDashboardData = [];
      state.inProgress = false;
    })

    builder.addCase(RespondentDashboard.fulfilled, (state, action) => {
      state.isUnblock=false;
      state.RespondentDashboardData = Array.isArray(action.payload.data.Table)
        ? action.payload.data.Table[0] : {};
      state.Message = ""
      state.RespondentDashboardUsers = Array.isArray(action.payload.data.Table1)
        ? action.payload.data.Table1 : [];
      state.inProgress = false;
    })

    builder.addCase(V_RespondentDashboard.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_RespondentDashboard.rejected, (state, action) => {
      state.V_RespondentDashboardUsers = [];
      state.V_RespondentDashboardData = [];
      state.inProgress = false;
    })

    builder.addCase(V_RespondentDashboard.fulfilled, (state, action) => {
      state.V_RespondentDashboardData = Array.isArray(action.payload.data.Table)
        ? action.payload.data.Table[0] : {};
      state.Message = ""
      state.V_RespondentDashboardUsers = Array.isArray(action.payload.data.Table1)
        ? action.payload.data.Table1 : [];
      state.inProgress = false;
    })

    builder.addCase(V_AllRespondents.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_AllRespondents.rejected, (state, action) => {
      state.V_RespondentDashboardUsers = [];
      state.V_RespondentDashboardData = [];
      state.inProgress = false;
    })

    builder.addCase(V_AllRespondents.fulfilled, (state, action) => {
      // state.V_RespondentDashboardData = Array.isArray(action.payload.data.Table)
      //   ? action.payload.data.Table[0] : {};
      // state.Message = ""
      state.V_RespondentDashboardUsers = Array.isArray(action.payload.data.Table)
        ? action.payload.data.Table : [];
      state.inProgress = false;
    })

    builder.addCase(RespondentDocuments.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(RespondentDocuments.rejected, (state, action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(RespondentDocuments.fulfilled, (state, action) => {
      state.RespondentDocumentsData = Array.isArray(action.payload.data) ? action.payload.data : [];
      state.inProgress = false;
    })

    builder.addCase(V_RespondentDocuments.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_RespondentDocuments.rejected, (state, action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(V_RespondentDocuments.fulfilled, (state, action) => {
      state.V_RespondentDocumentsData = Array.isArray(action.payload.data) ? action.payload.data : [];
      state.inProgress = false;
    })

    builder.addCase(UnblockUsers.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(UnblockUsers.rejected, (state, action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(UnblockUsers.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(GetSubmissionPdfDocZip.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetSubmissionPdfDocZip.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(GetSubmissionPdfDocZip.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(V_GetSubmissionPdfDocZip.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetSubmissionPdfDocZip.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(V_GetSubmissionPdfDocZip.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(downloadExcelReport.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(downloadExcelReport.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(downloadExcelReport.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(V_downloadExcelReport.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_downloadExcelReport.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(V_downloadExcelReport.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(RemindUser.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(RemindUser.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(RemindUser.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(V_RemindUser.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_RemindUser.rejected, (state,action) => {
      // state.error = action.error.message;
      state.inProgress = false;
    })

    builder.addCase(V_RemindUser.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    


    builder.addCase(UserFormData.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(UserFormData.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(UserFormData.fulfilled, (state, action) => {
      state.userFormDataValue = Array.isArray(action.payload.data.Table)
        ? action.payload.data.Table.map((item, index) => ({
          id: index,
          Company: item.Company,
          Details: item.Details,
        }))
        : [];
      state.inProgress = false;
    });


    builder.addCase(GetAllCycleForEntity.fulfilled, (state, action) => {
      state.UpcommingCycle = Array.isArray(action.payload.data)
        ? action.payload.data
        : []; // Return an empty array if action.payload.data is not an array
      state.inProgress = false;
    })


    builder.addCase(GetAllCycleForEntity.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAllCycleForEntity.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(DeleteCycleForEntity.fulfilled, (state, action) => {
      state.inProgress = false;
    })


    builder.addCase(DeleteCycleForEntity.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(DeleteCycleForEntity.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(GetAdminGroupsByUPNNotMappedWithEntity.fulfilled, (state, action) => {
      state.NotMappedWithEntityList = Array.isArray(action.payload?.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.ID,
          Label: item.Title,
          Value: item.ID
        })) : [];
      state.inProgress = false;
    })

    builder.addCase(GetAdminGroupsByUPNNotMappedWithEntity.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetAdminGroupsByUPNNotMappedWithEntity.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(V_GetAdminGroupsByUPNNotMappedWithEntity.fulfilled, (state, action) => {
      state.V_NotMappedWithEntityList = Array.isArray(action.payload?.data)
        ? action.payload.data.map(item => ({
          ...item,
          id: item.ID,
          Label: item.Title,
          Value: item.ID
        })) : [];
      state.inProgress = false;
    })


    builder.addCase(V_GetAdminGroupsByUPNNotMappedWithEntity.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetAdminGroupsByUPNNotMappedWithEntity.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(SendInvitationAndReminder.fulfilled, (state, action) => {
      state.inProgress = false;
    })


    builder.addCase(SendInvitationAndReminder.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(SendInvitationAndReminder.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(V_SendInvitationAndReminder.fulfilled, (state, action) => {
      state.inProgress = false;
    })


    builder.addCase(V_SendInvitationAndReminder.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_SendInvitationAndReminder.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    }
  )

    builder.addCase(GetPolicyByHFMCodeAndLanguageId.fulfilled, (state, action) => {
      state.PolicyDataNew= Array.isArray(action.payload.data) ? action.payload.data[0]:{};
      state.inProgress = false;
    })


    builder.addCase(GetPolicyByHFMCodeAndLanguageId.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(GetPolicyByHFMCodeAndLanguageId.rejected, (state,action) => {
      // state.error = action.error.message
      state.inProgress = false;
    })

    builder.addCase(V_GetPolicyByHFMCodeAndLanguageId.fulfilled, (state, action) => {
      state.V_PolicyDataNew= Array.isArray(action.payload.data) ? action.payload.data[0]:{};
      state.inProgress = false;
    })


    builder.addCase(V_GetPolicyByHFMCodeAndLanguageId.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(V_GetPolicyByHFMCodeAndLanguageId.rejected, (state,action) => {
      state.inProgress = false;
    })

    builder.addCase(DownloadArchivalExcelReport.pending, (state) => {
      state.inProgress = true;
    })

    builder.addCase(DownloadArchivalExcelReport.rejected, (state,action) => {
      state.inProgress = false;
    })

    builder.addCase(DownloadArchivalExcelReport.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(saveUnblockRequest.pending,(state)=>{
      state.inProgress = true;
    })

    builder.addCase(saveUnblockRequest.rejected,(state,action)=>{
      state.inProgress = false;
    })

    builder.addCase(saveUnblockRequest.fulfilled, (state, action) => {
      state.inProgress = false;
    })

    builder.addCase(getUnblockRequest.pending,(state)=>{
      state.inProgress = true;
    })

    builder.addCase(getUnblockRequest.rejected,(state,action)=>{
      state.inProgress = false;
    })

    builder.addCase(getUnblockRequest.fulfilled, (state, action) => {
      state.isUnblock = true;
      state.RespondentDashboardUsers = Array.isArray(action.payload.data.Table)
        ? action.payload.data.Table : {};
      state.inProgress = false;
    })
    
    builder.addCase(unblockRequest_Process.pending,(state)=>{
      state.inProgress = true;
    })

    builder.addCase(unblockRequest_Process.rejected,(state,action)=>{
      state.inProgress = false;
    })

    builder.addCase(unblockRequest_Process.fulfilled, (state, action) => {
      state.inProgress = false;
    })
  },
});

export const DcoiActions = DcoiSlice.actions;
export default DcoiSlice;
